import { Container, Grid, Typography, Box, } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Helmet } from 'react-helmet';
import Casestudyback from '../../../../Component/Casestudyback'
import Banner from "../../../../asset/images/insight/case_studies/banner-transforming-insurance-operations.webp"
import { Link } from 'react-router-dom';

export default function BordereauAutomation() {

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);

    return (
        <>
            <Helmet><meta charset="UTF-8" />
                <meta charset="UTF-8" />
                <title>25% Faster Bordereau Processing for Insurance Firm with Automation</title>
                <meta name="description" content="Discover how Bordereau Processing automation can reduce time by 25%, enhance accuracy & streamline workflows for global insurance firms with advanced solutions." />
                <link rel="canonical" href="https://decimalpointanalytics.com/case-study/bordereau-processing-insurance-firm-automation" />
            </Helmet>

            <Box id="case-studies" className='section sec_bg new_cs' component='section'>

                <Container maxWidth='lg' className='bdr'>

                    <Grid container spacing={3} alignItems="top" justifyContent='center'>
                        <Grid item lg={9} md={9} sm={12} xs={12}>
                            <Box>
                                <Typography variant='h3' className='subhead skblue al_center'>
                                    Success Stories
                                </Typography>
                                <Typography variant='h1' className='mainhead blue al_center'>
                                Transforming Insurance Operations <span className='lower'>with</span> Automated Bordereau Processing
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    <Box>
                        <img loading="lazy" src={Banner} className='w100' alt='Banner' />
                    </Box>

                    <Box className='whitebx'>

                        <Box>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Client Overview
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                            A global insurance and reinsurance firm responsible for managing cover holder submissions and onboarding data for new business entities across geographies.
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Problem Statement
                            </Typography> 

                            <Typography variant='h6' className='black jst'> 
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                        Inconsistent file submissions caused frequent compatibility issues with internal systems.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                        Manual processing of entity-level data consumed a full workday, introducing delays and increasing the risk of human error.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                        Lack of automation made data integration inefficient and error-prone.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                        Increased data volume from expanding portfolios strained operational bandwidth.
                                        </Typography>
                                    </li>
                                </ul>
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Solution Provided
                            </Typography> 

                            <Typography variant='h6' className='black jst'>
                            To resolve these challenges, Decimal Point Analytics implemented a <strong> custom Excel-based automation tool </strong>designed for high-volume entity processing. The solution included: 
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                        Structured data import pipelines to standardize raw file formats into system-compatible templates.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                        A fully automated <strong>data validation and preparation workflow,</strong> minimizing manual oversight.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                        Enhanced accuracy and consistency in entity onboarding using our <Link to="/data-solution-in-us" className='link'> Data Management Solutions. </Link>
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                        Reduced reliance on internal resources while boosting overall operational throughput.
                                        </Typography>
                                    </li>
                                </ul>
                            </Typography>
                        </Box>


                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Outcome
                            </Typography> 

                            <Typography variant='h6' className='black jst'>
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                        <strong>Processing time reduced by 20–25%,</strong> shrinking the task from a full day to a few hours.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                        Scaled operations to handle more workload with the same team.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                        Improved accuracy in entity data through built-in validation logic.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                        Delivered a reliable and scalable solution that increased overall client satisfaction.
                                        </Typography>
                                    </li> 
                                </ul>
                            </Typography>
                        </Box>

                        <Box mt={2}>

                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Key Takeaways
                            </Typography> 

                            <Typography variant='h6' className='black jst'>
                            Automating bordereau processing doesn’t just improve turnaround—it builds scalability, accuracy, and long-term operational resilience.
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                            Facing similar data challenges in insurance operations? <Link to="/contact-us#contact_form" className='link'>Talk to our experts</Link> to explore how our <strong>Insurance & Reinsurance Analytics</strong> and <strong>Automation Solutions</strong> can help you reduce errors, boost accuracy, and increase efficiency.
                            </Typography>

                        </Box>
                    </Box>

                    <Casestudyback />

                </Container>
            </Box>
        </>
    );
}